module.exports = __webpack_public_path__ + "images/frontpage_design@2x.png?01cb8c58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_design@2x.png
// module id = 631
// module chunks = 7